var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('center',[_c('h1',[_vm._v("404 Not Found")])]),_c('hr'),_c('center',[_vm._v("homepage-unterrainer-informatik")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }